import { localizedStrings } from '/src/js/localized-strings.js';

export {
  init,
  getLang,
  setLang,
  getLocalizedString,
}

let lang = 'fr'; // Default language
const supportedLanguages = ['fr', 'en', 'de', 'it'];

function init() {
  // Detect language
  lang = (navigator.language || navigator.userLanguage).slice(0, 2);
  if (!supportedLanguages.includes(lang)) {
    lang = 'en';
  }
  translateAllLocalizedStrings();
}

function getLang() {
  return lang;
}

function setLang(newLang) {
  if (supportedLanguages.includes(newLang)) {
    lang = newLang;
    document.documentElement.setAttribute('lang', newLang);
    window.dispatchEvent(new Event('languagechange'));
    translateAllLocalizedStrings();

    // Update aria-activedescendant for #language-select
    const languageSelect = document.getElementById('language-select');
    languageSelect.setAttribute('aria-activedescendant', `language-select-link-${newLang}`);
  } else {
    console.error(`Unsupported language: ${newLang}`);
  }
}

function translateAllLocalizedStrings() {
  for (const [id, string] of Object.entries(localizedStrings)) {
    const element = document.getElementById(id);
    if(!element) {
      console.error(`Element with id ${id} not found`);
      continue;
    }
    if (string[lang] === undefined) {
      console.error(`Missing translation for ${id} in ${lang}`);
      continue;
    }
    switch (string.type) {
      case 'aria-label':
        element.setAttribute('aria-label', string[lang]);
        break;
      case undefined:
        // Default case for strings without a type
        element.textContent = string[lang];
        break;
      default:
        console.error(`Unknown type for localized string: ${string.type}`);
    }
  }
}

function getLocalizedString(id) {
  const string = localizedStrings[id];
  if (string === undefined) {
    console.error(`Missing localized string: ${id}`);
    return id;
  }
  if (string[lang] === undefined) {
    console.error(`Missing translation for ${id} in ${lang}`);
    return id;
  }
  return string[lang];
}
